export const Header = ({ navigate }) => {
    return (
        <div className="title">
            <button className="header-button" onClick={() => navigate("/main")}>TABLEAU DE BORD</button>
            <button className="header-button" onClick={() => navigate("/settings")}>PARAMÈTRES</button>
            <button className="header-button" onClick={() => navigate("/profile")}>PROFIL</button>
        </div>
    )
}